import React from 'react';
import Cards from './Cards';
import Datas from './Data';

const Container = () => {
  return (
    <div className='bg-white text-black w-full'>
        <div className="max-w-[1240px] grid mx-auto mt-8 md:grid-cols-3">
            {Datas.map((data) => {
                return(
                    <div key={data.id} className="mt-10 py-5 px-12 flex flex-col justify-center items-center mx-auto text-center rounded-lg border-[3px] shadow-lg hover:scale-105 duration-500" >
                        <Cards {...data}/>
                    </div>
                )
            })}
        </div>
    </div>
  )
}

export default Container